<template>
  <div class="offer-item-container m-0 m-md-2 mb-2 mb-md-3" :id="'jobOffer' + jobOffer.id">
    <b-row class="mb-2 mx-0">
      <b-col cols="12" sm="5" class="mt-3 mt-sm-0">
        <b-row class="h-100">
          <b-col cols="12" lg="8">
            <div class="d-flex align-items-center h-100">
              <span class="font_size_1125rem font-weight-bold">
                {{ jobOffer.company_name }}{{ expiredDate ? `: Expires ${expiredDate}` : ''}}
              </span>
            </div>
          </b-col>
          <b-col cols="12" lg="4">
            <div
              class="d-flex align-items-center h-100 clickable"
              @click="$emit('show-matches-modal', jobOffer.id)"
            >
              <div>
                <svg v-if="matches > 0" style="width: 24px; height: 24px;" viewBox="0 0 24 24">
                  <path
                    fill="#393"
                    d="M21.4 7.5C22.2 8.3 22.2 9.6 21.4 10.3L18.6 13.1L10.8 5.3L13.6 2.5C14.4 1.7 15.7 1.7 16.4 2.5L18.2 4.3L21.2 1.3L22.6 2.7L19.6 5.7L21.4 7.5M15.6 13.3L14.2 11.9L11.4 14.7L9.3 12.6L12.1 9.8L10.7 8.4L7.9 11.2L6.4 9.8L3.6 12.6C2.8 13.4 2.8 14.7 3.6 15.4L5.4 17.2L1.4 21.2L2.8 22.6L6.8 18.6L8.6 20.4C9.4 21.2 10.7 21.2 11.4 20.4L14.2 17.6L12.8 16.2L15.6 13.3Z"
                  />
                </svg>
              </div>
              <span class="ml-2 no-wrap">{{ matches }} matches</span>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="5" cols="12" class="d-flex align-items-center justify-content-around">
        <template v-if="jobOffer.status !== JOB_OFFERS_STATUSES.CLOSED">
          <b-button
            :to="`/recruiter/edit-job-offer/${jobOffer.id}`"
            variant="v3_teal_outline"
            class="edit-button"
          >
            Edit
          </b-button>
          <b-button
            variant="v3_teal_outline"
            class="edit-button"
            @click="onFilledClick"
          >
            Filled
          </b-button>
          <b-button
            variant="v3_teal_outline"
            class="edit-button"
            @click="onClosedClick"
          >
            Closed
          </b-button>
        </template>
        <template v-else>
          <span>
            Status: {{ capitalize(jobOffer.status) }} {{ closedDate }}
          </span>
        </template>
      </b-col>
      <b-col sm="2" cols="12" class="d-flex align-items-center justify-content-around">
        <div
          class="d-flex justify-content-start justify-content-lg-end align-items-center mail-icon-wrapper"
        >
          <i
            v-if="parseInt(numberOfUnviewedMessages) === 0"
            class="mdi mdi-mailbox clickable"
          />
          <span v-else class="d-flex align-items-center clickable">
            <i class="mdi mdi-mailbox-up" />
            <span class=""> ({{ numberOfUnviewedMessages }}) </span>
          </span>
        </div>
        <!-- <div class="d-flex">
          <span
            class="text-center v3_color_white px-3"
            :class="{
              'badge-v3_kowloon': JOB_OFFERS_STATUSES.DRAFT === jobOffer.status,
              'badge-v3_blue_lagoon':
                JOB_OFFERS_STATUSES.ACTIVE === jobOffer.status ||
                JOB_OFFERS_STATUSES.FILLED === jobOffer.status,
              'badge-v3_gray': JOB_OFFERS_STATUSES.CLOSED === jobOffer.status,
            }"
          >
            {{ capitalize(jobOffer.status) }}
          </span>
        </div> -->
      </b-col>
    </b-row>

    <b-row class="m-0">
      <b-col cols="12" md="5" class="p-1 p-md-2">
        <div class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3">

          <b-row v-if="jobOffer.practice_name" class="my-2">
            <b-col>
              <span class="font-weight-bold">Facility:</span>
            </b-col>
            <b-col>
              {{ jobOffer.practice_name }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.specialty" class="my-2">
            <b-col>
              <span class="font-weight-bold">Specialty:</span>
            </b-col>
            <b-col>
              {{ jobOffer.specialty.title }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.subspecialty" class="my-2">
            <b-col>
              <span class="font-weight-bold">Subspecialty:</span>
            </b-col>
            <b-col>
              {{ jobOffer.subspecialty.title }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.location_zip_code" class="my-2">
            <b-col>
              <span class="font-weight-bold">Location:</span>
            </b-col>
            <b-col>
              {{ jobOffer.location_zip_code }}
            </b-col>
          </b-row>

          <b-row v-if="this.practiceTypeValue" class="my-2">
            <b-col>
              <span class="font-weight-bold">Practice Type:</span>
            </b-col>
            <b-col>
              {{ this.practiceTypeValue ? this.practiceTypeValue : ''}}
            </b-col>
          </b-row>

          <b-row v-if="this.maxCompValue" class="my-2">
            <b-col>
              <span class="font-weight-bold">Max Compensation:</span>
            </b-col>
            <b-col>
              ${{ this.maxCompValue ? this.maxCompValue : ''}}
            </b-col>
          </b-row>
          
          <!-- <b-row v-if="jobOffer.location_zip_code" class="my-2">
            <b-col cols="12">
              <span class="font-weight-bold">Location</span>
            </b-col>
            <b-col cols="12">
              {{ jobOffer.location_zip_code }}
            </b-col>
          </b-row> -->

          <!-- <b-row v-if="jobOffer.tracking_num" class="my-2">
            <b-col>
              <span class="font-weight-bold">PO or Tracking #</span>
            </b-col>
            <b-col>
              {{ jobOffer.tracking_num }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.external_url" class="my-2">
            <b-col cols="12">
              <span class="font-weight-bold">Job Board URL</span>
            </b-col>
            <b-col cols="12">
              {{ jobOffer.external_url }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.company_name" class="my-2">
            <b-col>
              <span class="font-weight-bold">Company</span>
            </b-col>
            <b-col>
              {{ jobOffer.company_name }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.location_zip_code" class="my-2">
            <b-col>
              <span class="font-weight-bold">Job Location Zip Code</span>
            </b-col>
            <b-col>
              {{ jobOffer.location_zip_code }}
            </b-col>
          </b-row> 

          <b-row v-if="jobOffer.posted_date" class="my-2">
            <b-col>
              <span class="font-weight-bold">Active Date</span>
            </b-col>
            <b-col>
              {{ $dayjs(jobOffer.posted_date).format('MM/DD/YYYY') }}
            </b-col>
          </b-row>

          <b-row v-if="jobOffer.posted_date" class="my-2">
            <b-col>
              <span class="font-weight-bold">Expiration Date</span>
            </b-col>
            <b-col>
              {{
                $dayjs(jobOffer.posted_date).add(90, 'day').format('MM/DD/YYYY')
              }}
            </b-col>
          </b-row>-->

          <template
            v-if="
              jobOffer.jobOfferJobQuestionVariableResponses &&
              jobOffer.jobOfferJobQuestionVariableResponses.length
            "
          >
            <b-row
              v-for="response in jobOffer.jobOfferJobQuestionVariableResponses"
              :key="`jor_${response.id}`"
              class="my-2"
            >
              <b-col>
                <span class="font-weight-bold">
                  {{ response.jobQuestionVariable.jobQuestion.talent_prompt }}
                </span>
              </b-col>
              <b-col>
                {{ response.value }}
              </b-col>
            </b-row>
          </template>
        </div>
      </b-col>
      <b-col cols="12" md="7" class="p-1 p-md-2 pb-2">
        <div
          class="h-100 border_1 border_primary_teal p-1 p-md-2 p-xl-3 mt-1 mt-md-0"
        >
          <recruiter-job-offer-message-center
            :messages="messages"
            :view-mode="viewMode"
            :is-messages-loading="isMessagesLoading"
            @mark-as-read="handleMarkAsRead"
            @new-msg-created="handleNewMsgCreated"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { JOB_OFFER_STATUSES } from '@/store';
import { capitalize } from '@/helpers/commonHelper';
import Api from '@/providers/Api';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import { VIEW_MODES } from '@/components/exchange/job-profiles-list/JobProfileJobOfferListItem';
import RecruiterJobOfferMessageCenter from '@/components/recruiter/job_offers/RecruiterJobOfferMessageCenter';
import { getNumberOfUnreadMessages } from '@/helpers/messagesHelper';

export default {
  name: 'RecruiterJobOffersItem',
  components: {
    RecruiterJobOfferMessageCenter,
  },
  props: {
    jobOffer: {
      validator: (prop) => typeof prop === 'object' || prop === null,
      default: null,
    },
  },
  countIntervalId: null,
  messagesIntervalId: null,
  data: function () {
    return {
      messages: [],
      isMessagesLoading: false,
      viewMode: VIEW_MODES.MESSAGES,
      numberOfUnviewedMessages: 0,
      jobQuestions: [],
      jobQuestionResponses:{},
      practiceTypeValue:'',
      maxCompValue:'',
    };
  },
  created: function () {
    this.getMessages();
    this.updateCountSubscription(true);
    this.updateMessagesSubscription(true);
    this.getJobQuestions();
    if (this.jobOffer.id) {
        this.getJobOfferData();
    } 
    //console.log(JSON.stringify(this.jobOffer));
  },
  mounted: function(){
    /// Scroll to offer when page redirected form purchase history ////
    if(this.$store.state.goToJoID)
    {
      // Get the target element by its ID on the purchase history page
      const targetElement = document.getElementById(`jobOffer${this.$store.state.goToJoID}`);
      // Check if the element exists
      if (targetElement) {
        // Use the `scrollIntoView` method to scroll to the target element
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
      this.$store.state.goToJoID = undefined;
    }
  },
  beforeDestroy: function () {
    if (this.$options.countIntervalId)
      clearInterval(this.$options.countIntervalId);
    if (this.$options.messagesIntervalId)
      clearInterval(this.$options.messagesIntervalId);
  },
  computed: {
    JOB_OFFERS_STATUSES: function () {
      return JOB_OFFER_STATUSES;
    },
    matches: function () {
      return (this.jobOffer || {}).jobProfileJobOfferMatchesCount || 0;
    },
    isMessagesOpen: function () {
      return [VIEW_MODES.MESSAGES, VIEW_MODES.NEW_MSG].includes(this.viewMode);
    },
    closedDate: function () {
      let date = this.jobOffer.closed_date;
      if (this.jobOffer.status === JOB_OFFER_STATUSES.FILLED) {
        date = this.jobOffer.filled_date;
      }
      return date ? `(${this.$dayjs(date).format('MM/DD/YYYY')})` : '';
    },
    expiredDate: function () {
      let paymentSuccessDate = this.jobOffer.payment_success_date;
      const paymentDate = (paymentSuccessDate) ? new Date(this.jobOffer.payment_success_date) : '';
      let offerDuration = this.jobOffer.job_offer_duration;
      const offerDays = (offerDuration) ? offerDuration : 0;
      (paymentDate) ? paymentDate.setDate(paymentDate.getDate() + offerDays) : '';
      return paymentDate ? `${this.$dayjs(paymentDate).format('MM/DD/YYYY')}` : '';
    },
  },
  methods: {
    capitalize: function (string) {
      return capitalize(string);
    },
    getMessages: async function () {
      this.isMessagesLoading = true;
      try {
        const messages = await Api.getJobOfferMessages(this.jobOffer.id);
        this.messages = messages;
        this.numberOfUnviewedMessages = getNumberOfUnreadMessages(messages);
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isMessagesLoading = false;
      }
    },
    handleMarkAsRead: async function (id) {
      try {
        const viewedDate = await Api.markMessageAsViewed(id);
        const index = this.messages.findIndex((message) => message.id === id);
        if (index === -1) return;
        this.$set(this.messages[index], 'to_first_viewed_date', viewedDate);
        if (this.numberOfUnviewedMessages > 0) {
          this.numberOfUnviewedMessages -= 1;
        }
      } catch (error) {
        process.env.NODE_ENV !== 'production' && console.error(error);
      }
    },
    handleNewMsgCreated: function (newMsg) {
      this.messages.unshift(newMsg);
    },
    updateCountSubscription: function (isEnable = false) {
      if (isEnable && !this.$options.countIntervalId) {
        this.$options.countIntervalId = setInterval(async () => {
          this.numberOfUnviewedMessages = await Api.getJobOfferUnviewedCount(
            this.jobOffer.id
          );
        }, 1000 * 60);
      } else if (!isEnable && this.$options.countIntervalId) {
        clearInterval(this.$options.countIntervalId);
        this.$options.countIntervalId = null;
      }
    },
    updateMessagesSubscription: function (isEnable = false) {
      if (isEnable && !this.$options.messagesIntervalId) {
        this.$options.messagesIntervalId = setInterval(async () => {
          const messages = await Api.getJobOfferMessages(this.jobOffer.id);
          this.messages = messages;
          this.numberOfUnviewedMessages = getNumberOfUnreadMessages(messages);
        }, 1000 * 60);
      } else if (!isEnable && this.$options.messagesIntervalId) {
        clearInterval(this.$options.messagesIntervalId);
        this.$options.messagesIntervalId = null;
      }
    },
    onFilledClick: async function () {
      await Api.setJobOfferStatusFilled(this.jobOffer.id);
      this.jobOffer.status = JOB_OFFER_STATUSES.FILLED;
    },
    onClosedClick: function () {
      this.$emit('job-offer-closed', this.jobOffer.id);
    },
    getJobQuestions: async function () {
      this.isLoading = true;
      try {
        this.jobQuestions = await Api.getJobQuestionsForGuestIcoBrowser();
        this.setJobQuestionResponses();
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.isLoading = false;
      }
    },
    getJobOfferData: async function () {
      this.loadingDetail = true;
      try {
        this.jobQuestionResponses = await Api.getJobOfferData(this.jobOffer.id);
        
        this.setJobQuestionResponses();
      } catch (error) {
        if (error && error.response && error.response.status === 403) {
          this.$toasted.error('You are not allowed to view this job offer', {
            duration: 3000,
          });
          this.$router.push('/recruiter/exchange');
        } else handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.loadingDetail = false;
      }
    },
    setJobQuestionResponses: function () {
      if (!this.jobQuestions || !this.jobQuestionResponses.jobQuestionResponses) return;
      Object.entries(this.jobQuestionResponses.jobQuestionResponses).forEach(
        ([id, value]) => {
          const index = this.jobQuestions.findIndex(
            (jq) => jq.id === parseInt(id)
          );
          if (index === -1) return;
          this.$set(this.jobQuestions[index], 'value', value);

          //let prKey = Object.keys(this.jobQuestions[0].value);
          if(this.jobQuestions[0].value)
          {
            this.practiceType(this.jobQuestions[0].value);
          }
          if(this.jobQuestions[1].value)
          {
            this.maxCompansation(this.jobQuestions[1].value);
          }
        }
      );
    },
    getObjectKeys(obj) {
      return Object.keys(obj);
    },
    practiceType: function(prValue) {
      const prValues = this.getObjectKeys(prValue);
      let prVal='';
      if(prValues.length > 0)
      {
        for (let i = 0; i < prValues.length; i++) {
          let prObj = this.jobQuestions[0].jobQuestionVariables.find(item => item.id === parseInt(prValues[i]));
          prVal +=  prObj ? `${prObj.input_label}` : '';
          if (i !== prValues.length - 1) { prVal +=  ' | ';}
        }
      }
      this.practiceTypeValue =  prVal;
    },
    maxCompansation: function(value) {
      let key = Object.keys(value)[0];
      let maxObj = this.jobQuestions[1].value ? this.jobQuestions[1].value[key] : [];
      this.maxCompValue =  maxObj[1] ? this.valueWithPrefixAndSuffix(parseInt(maxObj[1])) : 0 ;
    },
    // setJobQuestionResponses: function () {
    //   if(this.jobOffer.jobOfferJobQuestionResponses[0])
    //   {
    //     this.$set(this.jobQuestions[0], 'value', this.jobOffer.jobOfferJobQuestionResponses[0]);
        
    //   }
    //   if(this.jobOffer.jobOfferJobQuestionResponses[1])
    //   {
    //     this.$set(this.jobQuestions[1], 'value', this.jobOffer.jobOfferJobQuestionResponses[1]);
    //   }
    // },
    formattedValue: function (value) {
      const nf = new Intl.NumberFormat('en-US');
      return nf.format(value);
    },
    valueWithPrefixAndSuffix: function (value) {
      return `${this.formattedValue(value)}`;
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/v3.scss';

.offer-item-container {
  border-radius: 0;
  border: 1px solid $v3_color_teal;
  padding: 10px 0 0 0px;
}
.border_primary_teal {
  border: 1px solid $v3_color_teal;
}
.edit-button {
  height: 40px;
  width: 120px;
}
</style>
